import { render, staticRenderFns } from "./ClientDemographicsDashboardBuilder.vue?vue&type=template&id=66b088ac&scoped=true"
import script from "./ClientDemographicsDashboardBuilder.vue?vue&type=script&lang=js"
export * from "./ClientDemographicsDashboardBuilder.vue?vue&type=script&lang=js"
import style0 from "./ClientDemographicsDashboardBuilder.vue?vue&type=style&index=0&id=66b088ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b088ac",
  null
  
)

export default component.exports